<div class="card shadow-sm">
    <div class="card-body">
        <div class="d-flex align-items-center">
            <h5 class="m-0">{{ 'hub.quotations.details.offer.copy-offer' | translate }}</h5>
        </div>
        <p-messages
            severity="error"
            [enableService]="false"
            class="mt-3 mb-0"
            *ngIf="error$ | async; let error">
            <ng-template pTemplate>
                {{ 'common.generic-error-alt' | translate }}
                <a class="close" (click)="onDismissError()">
                    <fa-icon [icon]="['far', 'times']"></fa-icon>
                </a>
                <div
                    class="font-weight-bold"
                    *ngIf="error?.status === HTTP_STATUS.FORBIDDEN && error?.error?.message"
                >
                    {{ error?.error?.message }}
                </div>
            </ng-template>
        </p-messages>
    </div>

    <div class="card-body">
        <qwyk-quotations-offer-form
            [quotationOffer]="selectedQuotationOffer$ | async"
            (save)="onCreate($event)"
            [disabled]="loading$ | async"
            [openRateRequests]="openRateRequests$ | async"
        ></qwyk-quotations-offer-form>
    </div>
</div>
